import { CheckCheckIcon } from "lucide-react";
import { cn } from "@ibada/ui";

type NotificationListEndProps = {
  label: string;
  className?: string;
};

/** Closes a fully loaded inbox so the user knows nothing older is hidden below (the inbox only reaches back N days). */
export function NotificationListEnd({ label, className }: NotificationListEndProps) {
  return (
    <div className={cn("flex flex-col items-center gap-2 px-6 py-6 text-center", className)}>
      <span className="bg-muted text-muted-foreground inline-flex size-9 items-center justify-center rounded-full" aria-hidden>
        <CheckCheckIcon className="size-4" />
      </span>
      <p className="text-muted-foreground max-w-64 text-xs leading-relaxed">{label}</p>
    </div>
  );
}
